var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page forbit-cancel-tree" },
    [
      _c(
        "Modal",
        {
          staticClass: "page-modal",
          attrs: {
            width: "60%",
            "mask-closable": false,
            "footer-hide": true,
            title: _vm.$t("deviceSip.batch"),
            "class-name": "vertical-center-modal",
          },
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _vm.spinShow
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "div",
            { ref: "addBatchDevice", staticClass: "modalHeight adddevice-box" },
            [
              _c(
                "Row",
                { staticClass: "margin-bottom-30" },
                [
                  _c(
                    "i-col",
                    { staticClass: "area-box flex-box", attrs: { span: "12" } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("deviceSip.areaChosen"))),
                      ]),
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: { size: "large" },
                          model: {
                            value: _vm.currentAreaType,
                            callback: function ($$v) {
                              _vm.currentAreaType = $$v
                            },
                            expression: "currentAreaType",
                          },
                        },
                        _vm._l(_vm.areaTypeNameList, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.areaTypeLevel,
                              attrs: { value: item.areaTypeLevel },
                            },
                            [_vm._v(" " + _vm._s(item.areaTypeName) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "i-col",
                    { staticClass: "area-box flex-box", attrs: { span: "12" } },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.$t("deviceSip.areaNum")))]),
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: { size: "large" },
                          model: {
                            value: _vm.currentDeviceNum,
                            callback: function ($$v) {
                              _vm.currentDeviceNum = $$v
                            },
                            expression: "currentDeviceNum",
                          },
                        },
                        _vm._l(8, function (item) {
                          return _c(
                            "Option",
                            { key: item, attrs: { value: item } },
                            [_vm._v(" " + _vm._s(item) + " ")]
                          )
                        }),
                        1
                      ),
                      _c(
                        "Poptip",
                        {
                          attrs: {
                            trigger: "hover",
                            title: _vm.$t("deviceSip.note"),
                            placement: "left",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c("h4", { staticClass: "bacth-box-tip" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("deviceSip.bacthTip")) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _c("Icon", {
                            attrs: {
                              type: "md-help-circle",
                              size: "24",
                              color: "#FFB22B",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { staticClass: "margin-bottom-20" },
                [
                  _c(
                    "i-col",
                    {
                      staticClass: "label-box text-center",
                      attrs: { span: "3" },
                    },
                    [
                      _c("h4", [
                        _vm._v("*" + _vm._s(_vm.$t("deviceSip.baseConfig"))),
                      ]),
                    ]
                  ),
                  _c(
                    "i-col",
                    { attrs: { span: "20" } },
                    [
                      _c(
                        "Form",
                        {
                          ref: "addForm",
                          attrs: {
                            "label-width": 200,
                            model: _vm.addForm,
                            "label-colon": "",
                            rules: _vm.ruleValidateBaseDevice_batch,
                          },
                        },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                prop: "name",
                                label: _vm.$t("deviceSip.deviceName"),
                              },
                            },
                            [
                              _c("Input", {
                                attrs: {
                                  value: _vm.$t("deviceSip.nameTip"),
                                  size: "large",
                                  clearable: "",
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                prop: "funList",
                                label: _vm.$t("deviceSip.function"),
                              },
                            },
                            [
                              _c(
                                "RadioGroup",
                                {
                                  on: { "on-change": _vm.setFunList },
                                  model: {
                                    value: _vm.addForm.productType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.addForm, "productType", $$v)
                                    },
                                    expression: "addForm.productType",
                                  },
                                },
                                _vm._l(_vm.allDevList, function (item) {
                                  return _c(
                                    "Radio",
                                    {
                                      key: item.value,
                                      attrs: { label: item.value },
                                    },
                                    [_c("span", [_vm._v(_vm._s(item.label))])]
                                  )
                                }),
                                1
                              ),
                              Number(_vm.addForm.productType) == 0
                                ? _c(
                                    "Row",
                                    {
                                      staticClass: "margin-box",
                                      attrs: { gutter: "20" },
                                    },
                                    [
                                      _c(
                                        "i-col",
                                        { attrs: { span: "24" } },
                                        [
                                          _c(
                                            "Select",
                                            {
                                              attrs: {
                                                size: "large",
                                                placeholder: _vm.$t(
                                                  "newDeviceType.deviceTypeTip"
                                                ),
                                              },
                                              model: {
                                                value: _vm.addForm.deviceType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.addForm,
                                                    "deviceType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "addForm.deviceType",
                                              },
                                            },
                                            _vm._l(
                                              _vm.deviceTypeList,
                                              function (item) {
                                                return _c(
                                                  "Option",
                                                  {
                                                    key: item.value,
                                                    attrs: {
                                                      value: item.value,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.label) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "Row",
                                { attrs: { gutter: "20" } },
                                [
                                  _c(
                                    "i-col",
                                    { attrs: { span: "16" } },
                                    [
                                      _c(
                                        "CheckboxGroup",
                                        {
                                          model: {
                                            value: _vm.addForm.funList,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.addForm,
                                                "funList",
                                                $$v
                                              )
                                            },
                                            expression: "addForm.funList",
                                          },
                                        },
                                        _vm._l(_vm.allFunList, function (item) {
                                          return _c(
                                            "Checkbox",
                                            {
                                              key: item.value,
                                              attrs: {
                                                label: item.value,
                                                disabled:
                                                  Number(
                                                    _vm.addForm.productType
                                                  ) == 0
                                                    ? false
                                                    : true,
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(item.label)),
                                              ]),
                                            ]
                                          )
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "i-col",
                                    { attrs: { span: "2" } },
                                    [
                                      _c(
                                        "Poptip",
                                        {
                                          attrs: {
                                            trigger: "hover",
                                            title: _vm.$t("deviceSip.note"),
                                            placement: "left",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "content",
                                              fn: function () {
                                                return [
                                                  _c("h4", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "updateNewSip.funTitle"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("h4", [
                                                    _vm._v(
                                                      ' "' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "updateNewSip.callin"
                                                          )
                                                        ) +
                                                        '": ' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "updateNewSip.callInTip"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("h4", [
                                                    _vm._v(
                                                      ' "' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "updateNewSip.callout"
                                                          )
                                                        ) +
                                                        '": ' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "updateNewSip.callOutTip"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("h4", [
                                                    _vm._v(
                                                      ' "' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "deviceSip.monitor"
                                                          )
                                                        ) +
                                                        '": ' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "updateNewSip.monitorTip"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("h4", [
                                                    _vm._v(
                                                      ' "' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "updateNewSip.doorAuth"
                                                          )
                                                        ) +
                                                        '": ' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "updateNewSip.doorTip"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("h4", [
                                                    _vm._v(
                                                      ' "' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "deviceSip.lift"
                                                          )
                                                        ) +
                                                        '": ' +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "updateNewSip.liftTip"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: {
                                              type: "md-help-circle",
                                              size: "24",
                                              color: "#FFB22B",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { staticClass: "margin-bottom-20" },
                [
                  _c(
                    "i-col",
                    {
                      staticClass: "label-box text-center",
                      attrs: { span: "3" },
                    },
                    [_c("h4", [_vm._v("*" + _vm._s(_vm.$t("deviceSip.net")))])]
                  ),
                  _c(
                    "i-col",
                    { attrs: { span: "20" } },
                    [
                      _c(
                        "Form",
                        {
                          ref: "netForm",
                          attrs: {
                            "label-width": 200,
                            model: _vm.netForm,
                            "label-colon": "",
                            rules: _vm.ruleValidateNet1,
                          },
                        },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                prop: "mode",
                                label: _vm.$t("deviceSip.netType"),
                              },
                            },
                            [
                              _c(
                                "Row",
                                [
                                  _c(
                                    "i-col",
                                    { attrs: { span: "8" } },
                                    [
                                      _c(
                                        "RadioGroup",
                                        {
                                          model: {
                                            value: _vm.netForm.mode,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.netForm, "mode", $$v)
                                            },
                                            expression: "netForm.mode",
                                          },
                                        },
                                        [
                                          _c("Radio", { attrs: { label: 1 } }, [
                                            _c("span", [_vm._v("Static")]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "i-col",
                                    {
                                      staticClass: "flex-box1",
                                      attrs: { span: "1" },
                                    },
                                    [
                                      _c(
                                        "Poptip",
                                        {
                                          attrs: {
                                            trigger: "hover",
                                            title: _vm.$t("deviceSip.note"),
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "content",
                                              fn: function () {
                                                return [
                                                  _c("h4", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "deviceSip.netTip1"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: {
                                              type: "md-help-circle",
                                              size: "24",
                                              color: "#FFB22B",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.netForm.mode === 1
                            ? _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "mask",
                                    label: _vm.$t("deviceSip.mask"),
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      size: "large",
                                      placeholder: _vm.$t(
                                        "updateNewSip.maskTip"
                                      ),
                                      clearable: "",
                                    },
                                    on: {
                                      "on-blur": function ($event) {
                                        return _vm.validateIpAndMask()
                                      },
                                    },
                                    model: {
                                      value: _vm.netForm.mask,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.netForm, "mask", $$v)
                                      },
                                      expression: "netForm.mask",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.netForm.mode === 1
                            ? _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "gateway",
                                    label: _vm.$t("deviceSip.gateway"),
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      size: "large",
                                      placeholder: _vm.$t(
                                        "updateNewSip.gatewayTip"
                                      ),
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.netForm.gateway,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.netForm, "gateway", $$v)
                                      },
                                      expression: "netForm.gateway",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.netForm.mode === 1
                            ? _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "ip",
                                    label: _vm.$t("deviceSip.ip"),
                                  },
                                },
                                [
                                  _c(
                                    "Row",
                                    [
                                      _c(
                                        "i-col",
                                        { attrs: { span: "24" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              size: "large",
                                              placeholder:
                                                _vm.$t("updateNewSip.ip1"),
                                              clearable: "",
                                            },
                                            on: {
                                              "on-blur": function ($event) {
                                                return _vm.validateIpAndMask()
                                              },
                                            },
                                            model: {
                                              value: _vm.netForm.ip,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.netForm, "ip", $$v)
                                              },
                                              expression: "netForm.ip",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.netForm.mode === 1
                            ? _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "dns1",
                                    label: _vm.$t("deviceSip.dns1"),
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      size: "large",
                                      placeholder: _vm.$t("updateNewSip.dns1"),
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.netForm.dns1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.netForm, "dns1", $$v)
                                      },
                                      expression: "netForm.dns1",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.netForm.mode === 1
                            ? _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "dns2",
                                    label: _vm.$t("deviceSip.dns2"),
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      size: "large",
                                      placeholder: _vm.$t("updateNewSip.dns2"),
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.netForm.dns2,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.netForm, "dns2", $$v)
                                      },
                                      expression: "netForm.dns2",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { staticClass: "margin-bottom-20" },
                [
                  _c(
                    "i-col",
                    {
                      staticClass: "label-box text-center",
                      attrs: { span: "3" },
                    },
                    [_c("h4", [_vm._v("*" + _vm._s(_vm.$t("deviceSip.sip1")))])]
                  ),
                  _c(
                    "i-col",
                    { attrs: { span: "20" } },
                    [
                      _c(
                        "Form",
                        {
                          ref: "sipForm1",
                          attrs: {
                            "label-width": 200,
                            model: _vm.sipForm1,
                            "label-colon": "",
                            rules:
                              _vm.sipForm1.mode === 1
                                ? {}
                                : _vm.ruleValidateSip1_batch,
                          },
                        },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                prop: "mode",
                                label: _vm.$t("deviceSip.mode"),
                              },
                            },
                            [
                              _c(
                                "RadioGroup",
                                {
                                  model: {
                                    value: _vm.sipForm1.mode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.sipForm1, "mode", $$v)
                                    },
                                    expression: "sipForm1.mode",
                                  },
                                },
                                [
                                  _c("Radio", { attrs: { label: 1 } }, [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("deviceSip.mode1"))),
                                    ]),
                                  ]),
                                  _c("Radio", { attrs: { label: 2 } }, [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("deviceSip.mode2"))),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                prop: "account",
                                label: _vm.$t("deviceSip.user"),
                              },
                            },
                            [
                              _c(
                                "Row",
                                [
                                  _c(
                                    "i-col",
                                    { attrs: { span: "23" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.$t(
                                            "updateNewSip.userSipAccount"
                                          ),
                                          size: "large",
                                          placeholder: _vm.$t(
                                            "updateNewSip.userSipAccount"
                                          ),
                                          clearable: "",
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "i-col",
                                    {
                                      staticClass: "flex-box1",
                                      attrs: { span: "1" },
                                    },
                                    [
                                      _c(
                                        "Poptip",
                                        {
                                          attrs: {
                                            trigger: "hover",
                                            title: _vm.$t("deviceSip.note"),
                                            placement: "left",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "content",
                                              fn: function () {
                                                return [
                                                  _c("h4", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "deviceSip.sipTip"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: {
                                              type: "md-help-circle",
                                              size: "24",
                                              color: "#FFB22B",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.sipForm1.mode === 2
                            ? _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "password",
                                    label: _vm.$t("deviceSip.password"),
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      size: "large",
                                      placeholder: _vm.$t("deviceSip.password"),
                                      clearable: "",
                                      maxlength: 32,
                                    },
                                    model: {
                                      value: _vm.sipForm1.password,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.sipForm1, "password", $$v)
                                      },
                                      expression: "sipForm1.password",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.sipForm1.mode === 2
                            ? _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "serviceIp",
                                    label: _vm.$t("deviceSip.serverIp"),
                                  },
                                },
                                [
                                  _c(
                                    "Row",
                                    [
                                      _c(
                                        "i-col",
                                        { attrs: { span: "23" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              size: "large",
                                              placeholder: _vm.$t(
                                                "updateNewSip.serverIp"
                                              ),
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.sipForm1.serviceIp,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.sipForm1,
                                                  "serviceIp",
                                                  $$v
                                                )
                                              },
                                              expression: "sipForm1.serviceIp",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "i-col",
                                        {
                                          staticClass: "flex-box1",
                                          attrs: { span: "1" },
                                        },
                                        [
                                          _c(
                                            "Poptip",
                                            {
                                              attrs: {
                                                trigger: "hover",
                                                title: _vm.$t("deviceSip.note"),
                                                placement: "left",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "content",
                                                    fn: function () {
                                                      return [
                                                        _c("h4", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "deviceSip.ipTip"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                false,
                                                2201250411
                                              ),
                                            },
                                            [
                                              _c("Icon", {
                                                attrs: {
                                                  type: "md-help-circle",
                                                  size: "24",
                                                  color: "#FFB22B",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.sipForm1.mode === 2
                            ? _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "protocolType",
                                    label: _vm.$t("deviceSip.protocolType"),
                                  },
                                },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      model: {
                                        value: _vm.sipForm1.protocolType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.sipForm1,
                                            "protocolType",
                                            $$v
                                          )
                                        },
                                        expression: "sipForm1.protocolType",
                                      },
                                    },
                                    [
                                      _c("Radio", { attrs: { label: 1 } }, [
                                        _c("span", [_vm._v("UDP")]),
                                      ]),
                                      _c("Radio", { attrs: { label: 2 } }, [
                                        _c("span", [_vm._v("TCP")]),
                                      ]),
                                      _c("Radio", { attrs: { label: 3 } }, [
                                        _c("span", [_vm._v("TLS")]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.isExpandSip2
                ? _c(
                    "Row",
                    { staticClass: "margin-bottom-20" },
                    [
                      _c(
                        "i-col",
                        { staticClass: "text-center", attrs: { span: "3" } },
                        [_c("h4", [_vm._v(_vm._s(_vm.$t("deviceSip.sip2")))])]
                      ),
                      _c("i-col", { attrs: { span: "17", offset: "1" } }, [
                        _c("hr", { staticClass: "more-hr" }),
                      ]),
                      _c(
                        "i-col",
                        {
                          staticClass: "more-box",
                          attrs: { span: "2", offset: "1" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "area-box more-text",
                              on: { click: _vm.expandMore },
                            },
                            [_vm._v(_vm._s(_vm.$t("deviceSip.more")))]
                          ),
                          _c("span", {
                            staticClass: "more-img",
                            on: { click: _vm.expandMore },
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "Row",
                    { staticClass: "margin-bottom-20 relative-box" },
                    [
                      _c(
                        "i-col",
                        {
                          staticClass: "more-box position-box",
                          attrs: { span: "2", offset: "1" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "area-box more-text",
                              on: { click: _vm.expandMore },
                            },
                            [_vm._v(_vm._s(_vm.$t("deviceSip.close")))]
                          ),
                          _c("span", {
                            staticClass: "more-img tranform-box",
                            on: { click: _vm.expandMore },
                          }),
                        ]
                      ),
                      _c(
                        "i-col",
                        { staticClass: "text-center", attrs: { span: "3" } },
                        [_c("h4", [_vm._v(_vm._s(_vm.$t("deviceSip.sip2")))])]
                      ),
                      _c(
                        "i-col",
                        { attrs: { span: "20" } },
                        [
                          _c(
                            "Form",
                            {
                              ref: "sipForm2",
                              attrs: {
                                "label-width": 200,
                                model: _vm.sipForm2,
                                "label-colon": "",
                                rules:
                                  _vm.sipForm2.mode === 1
                                    ? _vm.emptyRule
                                    : _vm.ruleValidateSip2_batch,
                              },
                            },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "mode",
                                    label: _vm.$t("deviceSip.mode"),
                                  },
                                },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      model: {
                                        value: _vm.sipForm2.mode,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.sipForm2, "mode", $$v)
                                        },
                                        expression: "sipForm2.mode",
                                      },
                                    },
                                    [
                                      _c("Radio", { attrs: { label: 1 } }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("deviceSip.mode1"))
                                          ),
                                        ]),
                                      ]),
                                      _c("Radio", { attrs: { label: 2 } }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("deviceSip.mode2"))
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    prop: "account",
                                    label: _vm.$t("deviceSip.user"),
                                  },
                                },
                                [
                                  _c(
                                    "Row",
                                    [
                                      _c(
                                        "i-col",
                                        { attrs: { span: "23" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              value: _vm.$t(
                                                "updateNewSip.userSipAccount"
                                              ),
                                              size: "large",
                                              placeholder: _vm.$t(
                                                "updateNewSip.userSipAccount"
                                              ),
                                              clearable: "",
                                              disabled: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "i-col",
                                        {
                                          staticClass: "flex-box1",
                                          attrs: { span: "1" },
                                        },
                                        [
                                          _c(
                                            "Poptip",
                                            {
                                              attrs: {
                                                trigger: "hover",
                                                title: _vm.$t("deviceSip.note"),
                                                placement: "left",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "content",
                                                  fn: function () {
                                                    return [
                                                      _c("h4", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "deviceSip.sipTip"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ]),
                                            },
                                            [
                                              _c("Icon", {
                                                attrs: {
                                                  type: "md-help-circle",
                                                  size: "24",
                                                  color: "#FFB22B",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.sipForm2.mode === 2
                                ? _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        prop: "password",
                                        label: _vm.$t("deviceSip.password"),
                                      },
                                    },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          size: "large",
                                          placeholder:
                                            _vm.$t("deviceSip.password"),
                                          clearable: "",
                                          maxlength: 32,
                                        },
                                        model: {
                                          value: _vm.sipForm2.password,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.sipForm2,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression: "sipForm2.password",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.sipForm2.mode === 2
                                ? _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        prop: "serviceIp",
                                        label: _vm.$t("deviceSip.serverIp"),
                                      },
                                    },
                                    [
                                      _c(
                                        "Row",
                                        [
                                          _c(
                                            "i-col",
                                            { attrs: { span: "23" } },
                                            [
                                              _c("Input", {
                                                attrs: {
                                                  size: "large",
                                                  placeholder: _vm.$t(
                                                    "updateNewSip.serverIp"
                                                  ),
                                                  clearable: "",
                                                },
                                                model: {
                                                  value: _vm.sipForm2.serviceIp,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.sipForm2,
                                                      "serviceIp",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "sipForm2.serviceIp",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "i-col",
                                            {
                                              staticClass: "flex-box1",
                                              attrs: { span: "1" },
                                            },
                                            [
                                              _c(
                                                "Poptip",
                                                {
                                                  attrs: {
                                                    trigger: "hover",
                                                    title:
                                                      _vm.$t("deviceSip.note"),
                                                    placement: "left",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "content",
                                                        fn: function () {
                                                          return [
                                                            _c("h4", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "deviceSip.ipTip"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2201250411
                                                  ),
                                                },
                                                [
                                                  _c("Icon", {
                                                    attrs: {
                                                      type: "md-help-circle",
                                                      size: "24",
                                                      color: "#FFB22B",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.sipForm2.mode === 2
                                ? _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        prop: "protocolType",
                                        label: _vm.$t("deviceSip.protocolType"),
                                      },
                                    },
                                    [
                                      _c(
                                        "RadioGroup",
                                        {
                                          model: {
                                            value: _vm.sipForm2.protocolType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.sipForm2,
                                                "protocolType",
                                                $$v
                                              )
                                            },
                                            expression: "sipForm2.protocolType",
                                          },
                                        },
                                        [
                                          _c("Radio", { attrs: { label: 1 } }, [
                                            _c("span", [_vm._v("UDP")]),
                                          ]),
                                          _c("Radio", { attrs: { label: 2 } }, [
                                            _c("span", [_vm._v("TCP")]),
                                          ]),
                                          _c("Radio", { attrs: { label: 3 } }, [
                                            _c("span", [_vm._v("TLS")]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "detailBackBtn" },
            [
              _c(
                "Button",
                { attrs: { size: "large" }, on: { click: _vm.closeModal } },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("common.ensure")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content_win" },
        [
          _c(
            "modal",
            {
              ref: "resultModal",
              attrs: { type: _vm.modalType },
              on: { afterComfirm: _vm.closeModal },
            },
            [
              _c("div", { attrs: { slot: "info" }, slot: "info" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("updateNewSip.batchIpTip")) + ":"),
                ]),
                _c("p", [
                  _vm._v(_vm._s(_vm.startIp) + "-" + _vm._s(_vm.endIp)),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }